import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";
import PlusMinus from "../Components/PlusMinus";
import { ReactComponent as IconCrossRound } from "../Images/icon_cross_round.svg";
import LayoutModal from "../Layout/LayoutModal";
import { postJson } from "../Utils/apiUtils";

const GifticonSelectBox = ({ handleClickX, handleAddToCart, goodsCode }) => {
  const navigate = useNavigate();

  const [quantity, setQuantity] = useState(1);
  const [detail, setDetail] = useState({
    goodsName: "",
    brandName: "",
    salePrice: "",
    goodsImgS: "",
    limitDay: "",
    content: "",
  });
  const getGifticonDetail = async () => {
    try {
      const body = { goodsCode: goodsCode };

      const res = await postJson("/dashboard/gifticon/getDetail", body, navigate);

      if (res.code === 200) {
        const data = res.data;
        setDetail({
          goodsName: data.goodsName,
          brandName: data.brandName,
          salePrice: data.salePrice,
          goodsImgS: data.goodsImgS,
          limitDay: data.limitDay,
          content: data.content,
        });
      }
    } catch (error) {
      console.log("기프티콘 상세 가져오기 중 에러:", error);
      throw error;
    }
  };

  useEffect(() => {
    getGifticonDetail();
  }, []);

  return (
    <Box>
      {/* 우측 상단 X버튼 */}
      <div style={{ width: "740px", display: "flex" }}>
        <div />
        <div style={{ marginLeft: "auto" }}>
          <IconCrossRound
            onClick={handleClickX}
            style={{ cursor: "pointer" }}
          />
        </div>
      </div>

      {/* 스크롤 박스 */}
      <div
        className="scrollView"
        style={{ paddingRight: "6px", height: "510px" }}
      >
        <div style={{ display: "flex", marginTop: "20px" }}>
          <div
            style={{
              width: "289px",
              height: "260px",
              backgroundColor: "#f5f5f5",
            }}
          >
            <img
              src={detail.goodsImgS}
              style={{ width: "100%", height: "100%" }}
            />
          </div>

          <div style={{ marginLeft: "18px" }}>
            <p className="bold-text">{detail.brandName}</p>
            <p className="medium-text" style={{ fontSize: "24px" }}>
              {detail.goodsName}
            </p>
            <p
              className="bold-text"
              style={{ fontSize: "30px", marginTop: "30px" }}
            >
              {detail.salePrice?.toLocaleString()}원
            </p>
            <hr
              color="#e4e4e4"
              style={{
                marginTop: "20px",
                border: 0,
                height: "1px",
              }}
            />
            <div style={{ display: "flex" }}>
              <p style={{ color: "#555555" }}>유효기간</p>
              <p className="medium-text" style={{ marginLeft: "auto" }}>
                {detail.limitDay?.toLocaleString()}일
              </p>
            </div>
            <div style={{ margin: "20px 0" }}>
              <PlusMinus
                value={quantity}
                setValue={setQuantity}
                updateQuantity={null}
              />
            </div>
            <div style={{ display: "flex" }}>
              <p className="medium-text" style={{ color: "#555555" }}>
                주문금액
              </p>
              <p
                className="bold-text"
                style={{ fontSize: "20px", marginLeft: "auto" }}
              >
                {(detail.salePrice * quantity)?.toLocaleString()}원
              </p>
            </div>
            <div
              className="blueBorderBtn-base center"
              style={{
                width: "433px",
                height: "60px",
                borderRadius: "10px",
                margin: "30px 0",
              }}
              onClick={() => handleAddToCart(quantity, goodsCode)}
            >
              담기
            </div>
          </div>
        </div>
        <div
          className="grayBox"
          style={{
            width: "740px",
            height: "auto",
            borderRadius: "10px",
            padding: "14px",
            boxSizing: "border-box",
          }}
        >
          <p
            className="bold-text"
            style={{ fontSize: "15px", color: "#656565" }}
          >
            상품 설명 및 유의사항
          </p>
          <p style={{ fontSize: "14px", color: "#888888", marginTop: "10px" }}>
            {detail.content}
          </p>
        </div>
      </div>
    </Box>
  );
};

const GifticonSelect = ({ handleClickX, handleAddToCart, goodsCode }) => {
  return (
    <LayoutModal
      Modal={
        <GifticonSelectBox
          handleClickX={handleClickX}
          handleAddToCart={handleAddToCart}
          goodsCode={goodsCode}
        />
      }
    />
  );
};

const Box = styled.div`
  width: 800px;
  box-sizing: border-box;
  padding: 30px;
  border-radius: 20px;
  background-color: #ffffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.2);
`;

export default GifticonSelectBox;
